export default {
  namespaced: true,
  state: {
    trialEntryId: null,
  },
  mutations: {
    SET_TRIAL_ENTRY_ID(state, payload) {
      state.trialEntryId = payload;
    },
    INIT(state) {
      state.trialEntryId = null;
    },
  },
  getters: {
    getTrialEntryId(state) {
      return state.trialEntryId;
    },
    
  },
  actions: {
    setTrialEntryId({commit}, payload) {
      commit('SET_TRIAL_ENTRY_ID', payload);
    },
    init({commit}) {
      commit('INIT');
    }
  }
}